export const getDefaultCurrency = (pharmacyPOS) => {
	return pharmacyPOS?.allowedCurrencies?.[0] || "INR";
};

export const getSubtotal = (cart = []) =>
	cart.reduce((sum, item) => sum + Number(item.salePrice || 0) * Number(item.quantity || 0), 0);

export const getDiscountAmount = (subtotal, discountType, discountValue) => {
	const value = Number(discountValue || 0);

	if (discountType === "Percentage") {
		return (subtotal * value) / 100;
	}

	return value;
};

export const getTaxAmount = (taxableAmount, taxRate) => {
	const rate = Number(taxRate || 0);
	return (taxableAmount * rate) / 100;
};

export const calculateTotals = ({
	cart = [],
	discountType = "Fixed",
	discountValue = 0,
	transportCost = 0,
	taxRate = 0,
}) => {
	const subtotal = getSubtotal(cart);
	const discount = getDiscountAmount(subtotal, discountType, discountValue);
	const transport = Number(transportCost || 0);
	const taxable = subtotal - discount + transport;
	const tax = getTaxAmount(taxable, taxRate);
	// const rawNetTotal = taxable + tax;
	const netTotal = taxable + tax;

	return {
		subtotal,
		discount,
		transport,
		tax,
		netTotal,
	};
};

export const buildInvoicePayload = ({
	cart,
	discountType,
	discountValue,
	taxRate,
	netTotal,
	paidType,
	paymentData,
	customerType,
	selectedPatient,
	prescriptionData,
	pharmacyPOS,
	taxType,
	tax,
	taxPercentage
}) => {
	const items = cart.map((item) => ({
		medicineQunatity: item.quantity,
		medicineName: item.saltName,
		brandName: item.brandName,
		stockId: item.selectedBatchId,
		itemId: item._id,
		batchNumber: item.batchNumber,
		productForm: item.productForm,
		unitPrice: item.salePrice,
		discount: 0,
		isOTC: item.isOTC
	}));

	const body = {
		clinicId: pharmacyPOS?.hospital_id,
		pharmacyId: pharmacyPOS?._id,
		discountType: discountType.toLowerCase(),
		discount: Number(discountValue),
		taxType: taxType || "",
		taxPercentage: Number(taxPercentage),
		tax: Number(tax),
		netTotal: Number(netTotal),
		// TODO: support multiple currency conversions when requirements are finalised
		// otherNetTotalPrice: Number((Number(netTotal) * exchangeRate).toFixed(2)),
		currencyType: paymentData.currency || getDefaultCurrency(pharmacyPOS),
		paymentType: paymentData.type,
		isConversion: false,
		customerType,
		totalPaid: Number(paymentData.amount),
		isPartialPaid: paidType === "partial",
		isSettled: paymentData.isSettle,
		zigConversionValue: 0,
		items,
	};

	if (paymentData.isSettle) {
		body.isPaid = true;
	} else {
		body.isPaid = paidType === "full";
	}

	if (customerType === "inpatient" && selectedPatient) {
		if (prescriptionData) {
			body.patientId = selectedPatient._id;
			body.patientName = selectedPatient.name;
		} else {
			body.patientId = selectedPatient._id;
			body.patientName = selectedPatient.full_name;
		}
	} else {
		body.patientName = paymentData.patientName || "Walk-in Customer";
	}

	return body;
};

